// extracted by mini-css-extract-plugin
export default {"loginContainer":"Register_loginContainer__gL5Tu","loginForm":"Register_loginForm__aujME","formGroup":"Register_formGroup__CQTfn","haveAccount":"Register_haveAccount__zW9Fq"};